import styled from "styled-components";

export const Socials = styled.div`
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;
